import Dashboard from "../modules/admin/dashboard";
import UserList from "../modules/admin/user-list";

export const Admins = [
  {
    path: "dashboard",
    element: <Dashboard />,
  },
  {
    path: "manage-user",
    element: <UserList />,
  },
];
